document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".category-filter");
    const products = document.querySelectorAll(".product-container");

    if (!buttons.length) {
        return;
    }
    // Get the active category
    let activeCategory = document.querySelector(".category-filter.active")

    if (activeCategory) {
        activeCategory = activeCategory.getAttribute("data-category");
    }

    buttons.forEach(button => {
        button.addEventListener("click", function (e) {
            e.preventDefault();

            // Remove the active class from all buttons
            buttons.forEach(btn => btn.classList.remove("active"));
            this.classList.add("active");

            const category = this.getAttribute("data-category");
            const categoryContainers = document.querySelectorAll(".category-container");
            categoryContainers.forEach(container => {
                if(container.classList.contains(`category-${category}`)) {
                    container.classList.add("active");
                    return;
                }
                container.classList.remove("active");
            })  
        });
    });
    
    // // Function to adjust the height of the products wrapper based on the category with the largest height
    // function adjustWrapperHeight() {
    //     let productsWrapper = document.querySelector(".products-wrapper");
    //     if (!productsWrapper) return;
    
    //     let maxHeight = 0;
    
    //     // get the height of each category and sum the height of the first half of the products
    //     document.querySelectorAll(".category-filter").forEach(filter => {
    //         let category = filter.dataset.category;
    //         let categoryProducts = document.querySelectorAll(".product-container.category-" + category);
    //         let categoriesNav = document.querySelector(".categories-nav");
    
    //         // calculate the height of the category
    //         let categoryHeight = 0;
    //         let count = categoryProducts.length; // total number of products in the category
    
    //         // add the height of categories-nav
    //         if (categoriesNav) {
    //             categoryHeight += categoriesNav.offsetHeight;
    //         }
    
    //         // Verify if the number of products is even or odd and calculate the number of products to consider for the height
    //         let productsToConsider = count;
    //         if (count % 2 === 0) {
    //             productsToConsider = count / 2; 
    //         } else {
    //             productsToConsider = Math.ceil(count / 2); // consider the first half of the products and round up
    //         }
    
    //         // Sum the height of the first half of the products
    //         for (let i = 0; i < productsToConsider; i++) {
    //             let product = categoryProducts[i];
    //             product.style.display = "block"; 
    //             categoryHeight += product.offsetHeight + 28; // + margin-top
    //         }
    
    //         // Update the maxHeight if the category height is greater
    //         maxHeight = Math.max(maxHeight, categoryHeight);
    
    //         // Hide the products if the category is not active
    //         if (!filter.classList.contains("active")) {
    //             categoryProducts.forEach(product => {
    //                 product.style.display = "none";
    //             });
    //         }
    //     });
    
    //     // Apply the maxHeight to the products wrapper
    //     productsWrapper.style.height = maxHeight + "px";
    // }
    
    // // Function to check the screen width and adjust the height of the products wrapper
    // function checkScreenWidthAndAdjust() {
    //     if (window.matchMedia("(min-width: 1024px)").matches) {
    //         adjustWrapperHeight();
    //     } else {
    //         // If the screen width is less than 1024px, remove the height set
    //         let productsWrapper = document.querySelector(".products-wrapper");
    //         if (productsWrapper) {
    //             productsWrapper.style.height = "";
    //         }
    //     }
    // }
    
    // // Adjust the height of the products wrapper on page load if the screen width is greater than 1024px
    // checkScreenWidthAndAdjust();
    
    // // adjust the height of the products wrapper when a category is clicked
    // document.querySelectorAll(".category-filter").forEach(filter => {
    //     filter.addEventListener("click", function () {
    //         setTimeout(checkScreenWidthAndAdjust, 300);
    //     });
    // });
    
    // // adjust the height of the products wrapper when the screen is resized
    // window.addEventListener("resize", checkScreenWidthAndAdjust);
});
